import axios from "axios";
import http from "./http";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const loginAPI = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/admin/login`, formData);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getCurrentDateTime = async (timezoneId) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/misc/current-time`, {
      utc_offset_minutes: timezoneId,
    });
    return res?.data?.data;
  } catch (error) {
    console.log(error);
  }
};

export const getDispatchReport = async (path, date) => {
  try {
    const response = await http.get(
      `${API_BASE_URL}admin/${path}${
        date?.startDate && date?.endDate
          ? `?startDate=${date?.startDate}&endDate=${date?.endDate}`
          : ""
      }`,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (err) {
    if (err.response?.data instanceof Blob) {
      try {
        const errorText = await err.response.data.text();
        const errorJson = JSON.parse(errorText);
        return errorJson;
      } catch (parseErr) {
        return { message: "Something went wrong" };
      }
    }
    return { message: "Network error" };
  }
};
